AccountStore.dispatchToken = MakeShiftEmployeeDispatcher.register(AccountStore.dispatchCallback);

AccountStore.onAccountHandler = function (accountData, response) {
  AccountStore.account = accountData.models[0].present();
  AccountStore.trigger('account:load:success', AccountStore.account);
};

AccountStore.onCoreAccountSuccess = function(accountData, response) {
  AccountStore.coreAccount = accountData.models[0].attributes.data;
  AccountStore.trigger('core:account:load:success', AccountStore.coreAccount);
}

AccountStore.onAccountError = function(collection, error) {
  if (error.status === 401) {
    Utils.signOut();
    LoginStore.trigger('login:error', error);
  }
};

AccountStore.onTokenInvalidError = function(collection, error) {
  if (error.status === 401) {
    Utils.signOut();
    LoginStore.trigger('login:tokenUnauthorized');
  }
};

AccountStore.on('change', (data) => {
  // AccountStore.trigger('account:view:reload');
});

AccountStore.updateSuccessCallback = function (data) {
  AccountStore.trigger('account:updateSuccess', data.present());
};

AccountStore.updateErrorCallback = function (data, error) {
  let errorMessage = "";
  if (error.responseJSON.errors) {
    errorMessage = error.responseJSON.errors.join(', ');
  }
  AccountStore.trigger(
    'account:updateError',
    `${error.responseJSON.error_message}: ${errorMessage}`,
  );
};

AccountStore.updatePasswordSuccessCallback = function (data) {
  AccountStore.trigger('password:update:success', data);
};

AccountStore.updatePasswordErrorCallback = function (collection, error) {
  const errors = { errors: error.responseJSON.error_message };
  AccountStore.trigger('password:update:failed', errors);
};

AccountStore.validatePasswordFailure = function (data) {
  AccountStore.trigger('password:validate:failure', data.errors);
};

AccountStore.validatePasswordSuccess = function (data) {
  AccountStore.trigger('password:validate:success');
};

AccountStore.getAccount = function () {
  let data = {};
  this.models.map((d) => {
    if (d.attributes.data.account) {
      data = d.attributes.data.account;
    }
  });
  return data;
};
